import type { Filter, FilterDataSearch } from '@/app/common/filters/core/filtersTypes.ts';
import { FilterSearchPill } from '@/app/common/filters/types/search/FilterSearchPill.ts';
import type { FilterTypeBehaviour } from '@/app/common/filters/types/filterTypeDefinition.ts';
import { optionChips } from '@/app/common/filters/types/optionChips.ts';

const dataOf = (filter: Filter) => filter.data as FilterDataSearch;

export const searchType: FilterTypeBehaviour = {
  chips: optionChips,
  pillLabels: FilterSearchPill,
  serialise: (filter) => {
    const selectedValues = dataOf(filter).options.reduce(
      (result: string[], option) => (option.selected ? result.concat(option.value) : result),
      []
    );

    return selectedValues.length > 0 ? selectedValues.join(',') : undefined;
  },
  isSelected: (filter) => !!dataOf(filter).options.find((option) => option.selected),
  resetValue: (filter) => ({
    ...filter,
    data: { ...dataOf(filter), options: dataOf(filter).options.map((option) => ({ ...option, selected: false })) },
  }),
  selectedOptions: (filter) => dataOf(filter).options.filter((option) => option.selected),
};
